import { render, staticRenderFns } from "./AveineQuizForm.vue?vue&type=template&id=1baf9c91"
import script from "./AveineQuizForm.vue?vue&type=script&lang=js"
export * from "./AveineQuizForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports